<div fxLayout="column">
    <div class="chart-container">
        <ngx-charts-pie-chart [view]="[110, 110]" [arcWidth]="0.5" [results]="data" [doughnut]="true"
            [scheme]="colorScheme" [animations]="false" [tooltipDisabled]="false">
            <ng-template #tooltipTemplate let-model="model">
                <h5>{{model.name}}</h5>
                {{model.value}}GB
            </ng-template>
        </ngx-charts-pie-chart>
    </div>
    <div class="disk-info">
        <h4 *ngIf="text" [matTooltip]="caption">{{text}} <small *ngIf="textDetail">{{textDetail}}</small></h4>
    </div>
</div>